var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({backgroundImage:'url('+ _vm.banner_bg +')'}),attrs:{"id":"banner"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"page-title"},[_c('div',{staticClass:"main-en"},[_vm._v(_vm._s(_vm.mainen))]),_vm._v(" "),_c('div',{staticClass:"main-zh"},[_vm._v(_vm._s(_vm.mainzh))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c84d514","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sub/Banner.vue
// module id = null
// module chunks = 